<template>
  <AppLayout>
    <VFlex>
      <h1 class="primary--text mb-4">
        {{ $nt('heading') }}
      </h1>
      <VCard>
        <VDataTable
          :headers="headers"
          :items="agencies"
          class="text-xs-left"
          :rows-per-page-items="[15]"
          :total-items="paginationTotal"
          :pagination.sync="pagination"
          :loading="isLoading"
        >
          <template
            slot="items"
            slot-scope="props"
          >
            <tr
              :key="props.index"
              @click="$router.push({name: 'agencyOverview.admin', params: { agencyId: props.item.id}})"
            >
              <td>{{ props.item.number }}</td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.commission }}</td>
            </tr>
          </template>
        </VDataTable>

        <VCardActions>
          <VSpacer />
          <AgencyCreate @onSuccess="getPaginatedData" />
        </VCardActions>
      </VCard>
    </VFlex>
  </AppLayout>
</template>

<script>
import PaginationApi from '@/api/PaginationApi'
import AgencyCreate from '@/components/routes/agencies/AgencyCreate'

export default {
  name: 'AgenciesList',
  components: { AgencyCreate },
  data () {
    return {
      url: 'agencies',
      isLoading: false,
      agencies: [],
      pagination: {},
      paginationTotal: 0,
      headers: [
        { text: this.$nt('number'), value: 'number', align: 'left', index: '0' },
        { text: this.$nt('name'), value: 'name', align: 'left', index: '1' },
        {
          text: this.$nt('commission'),
          value: 'commission',
          align: 'left',
          index: '2'
        }
      ]
    }
  },
  methods: {
    async getPaginatedData () {
      this.isLoading = true
      try {
        const response = await PaginationApi.getPaginatedData(this.url, undefined, this.pagination.page)
        this.paginationTotal = response.total
        this.agencies = response.data
      } catch (e) {
        this.$notification(e)
      }
      this.isLoading = false
    }
  },
  watch: {
    pagination: {
      handler: 'getPaginatedData'
    }
  }
}
</script>
